import { render, staticRenderFns } from "./K12Filters.vue?vue&type=template&id=21dd1235&scoped=true"
import script from "./K12Filters.vue?vue&type=script&lang=ts"
export * from "./K12Filters.vue?vue&type=script&lang=ts"
import style0 from "./K12Filters.vue?vue&type=style&index=0&id=21dd1235&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dd1235",
  null
  
)

export default component.exports